export const getParentFolders = (obj, folders = []) => {
  if (!obj?.parentFolder || !obj) return folders;
  if (obj?.parentFolder) {
    folders.push(obj.parentFolder);
  }
  return getParentFolders(obj.parentFolder, folders);
};
